import React from 'react'
import Checkout from '@components/v4/checkout/Index'

const CatalogCheckout = (props) => <Checkout {...props} />

export default CatalogCheckout
